// @flow
import React, { useState } from 'react';
import { PaginationControl } from 'components/molecules/paginationControl';
import HorizontalCarousel from 'components/templates/horizontalCarouselModule';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    completedProjects: Object,
    sectionHeading: string,
  },
};

const CompletedProjects = (props: Props) => {
  const {
    completedProjects: { completedProjects, mediaPath },
    sectionHeading,
  } = props.data;

  const { height } = useViewport();
  const [count, setCount] = useState(1);
  const [previousImage, setPreviousImage] = useState(null);
  const [image, setImage] = useState(null);

  let result = {};
  for (let i = 0; i < completedProjects.length; i++) {
    result[i + 1] = completedProjects[i];
    result[i + 1].sub_heading = completedProjects[i].sub_heading;
    result[i + 1].heading = sectionHeading;
    result[i + 1].description = completedProjects[i].description;
    result[i + 1].imagesToFilter = [
      completedProjects[i].picture1 && completedProjects[i].picture1,
      completedProjects[i].picture2 && completedProjects[i].picture2,
      completedProjects[i].picture3 && completedProjects[i].picture3,
      completedProjects[i].picture4 && completedProjects[i].picture4,
      completedProjects[i].picture5 && completedProjects[i].picture5,
    ];
    result[i + 1].images = result[i + 1].imagesToFilter.filter(Boolean);
  }

  const pagination = Object.keys(result);

  const next = () => {
    setPreviousImage(result[count].images);
    if (count < pagination.length) {
      setCount(count + 1);
      setImage(result[count + 1].images);
    } else {
      setCount(1);
      setImage(result[1].images);
    }
  };

  const previous = () => {
    setPreviousImage(result[count].images);
    if (count > pagination[0]) {
      setCount(count - 1);
      setImage(result[count - 1].images);
    } else if (count === 1) {
      setCount(pagination.length);
      setImage(result[pagination.length].images);
    }
    setPreviousImage(result[count].image);
  };

  let bannerImageUrl = result[count].images;

  if (pagination.length === 0) {
    return null;
  }

  return (
    <div className={'horizontal-module section-container'} style={{ height }}>
      <div className={'section-content'}>
        <HorizontalCarousel
          next={next}
          count={count}
          result={result}
          type={'projects'}
          previous={previous}
          displayCard={false}
          displayCount={false}
          pageValue={pagination}
          mediaPath={mediaPath.web}
          previousImage={previousImage}
          image={image || bannerImageUrl}
        />
      </div>
      <div className={'pagination-item'}>
        <PaginationControl
          onNextClick={next}
          currentIndex={count}
          theme={'light-theme'}
          total={pagination.length}
          onPreviousClick={previous}
          className={'top-pagination-item'}
        />
      </div>
    </div>
  );
};

export default CompletedProjects;
